import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import BaseModal from '../utils/BaseModal/BaseModal';
import { notifyError, notifyInfo } from '../../../utils/notify';
import { ButtonWrapper, CancelButton, Form, SubmitButton } from './EditChatDisplayNameModal.styles';
import Input from '../../utils/inputs/Input/Input';
import { useDispatch, useSelector } from 'react-redux';
import { editDisplayName } from '../../../store/slices/collections/asyncThunks';
import { selectCollectionsActionsPending } from '../../../store/slices/collections/slice';

export const editDisplayNameFormSchema = yup
  .object({ name: yup.string().trim().required('Name is required') })
  .required();

const EditChatDisplayNameModal = ({ modalRef, userInfluencerId, onSuccess, influencerId }) => {
  const dispatch = useDispatch();
  const { editDisplayName: editDisplayNamePending } = useSelector(selectCollectionsActionsPending);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: '',
    },
    delayError: 300,
    resolver: yupResolver(editDisplayNameFormSchema),
  });

  const onSubmit = data => {
    let { name } = data;

    dispatch(editDisplayName({ userInfluencerId, name, ...(influencerId && { influencerId }) }))
      .unwrap()
      .then(() => {
        modalRef.current.hide();
        onSuccess();
        notifyInfo('Name edited successfully!');
      })
      .catch(err => {
        notifyError(err.message);
      });
  };

  return (
    <BaseModal
      title="Edit name"
      ref={modalRef}
      onClose={() => {
        modalRef.current.hide();
      }}
      onAfterClose={() => {
        reset();
      }}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Input label="Name" placeholder="Enter name" {...register('name')} error={errors.name?.message} />
        <ButtonWrapper>
          <CancelButton
            title="Cancel"
            onClick={() => {
              reset();
              modalRef.current.hide();
            }}
            type="button"
          />
          <SubmitButton type="submit" title="Save" isLoading={editDisplayNamePending} />
        </ButtonWrapper>
      </Form>
    </BaseModal>
  );
};

export default EditChatDisplayNameModal;
